import classnames from 'classnames';
import { map, get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

import Level2Header from './Level2Header';
import Level3Option from './Level3Option';

const Level2Section = ({ l1Label, l2Option, trackNavigation, trackNavigationClick }) => (
  <div
    className={classnames('TopNavigationLevel2Section', {
      'TopNavigationLevel2Section--no-header': !l2Option.label,
    })}
  >
    {l2Option.label && (
      <div className="TopNavigationLevel2Section__category-link">
        <Level2Header
          // used to be mainLinkLabel
          l1Label={l1Label}
          title={l2Option.label}
          href={l2Option.mainLinkUrl}
          trackNavigation={trackNavigation}
          trackNavigationClick={trackNavigationClick}
        />
      </div>
    )}
    <ul className="TopNavigationLevel2Section__list">
      {map(get(l2Option, 'subNavigations'), l3Option => (
        <li key={`${l3Option.id}--desktop`}>
          <Level3Option
            l1Label={l1Label}
            l2Label={l2Option.label}
            l3Option={l3Option}
            trackNavigation={trackNavigation}
            trackNavigationClick={trackNavigationClick}
          />
        </li>
      ))}
    </ul>
    <style jsx>
      {`
        .TopNavigationLevel2Section {
          margin-bottom: ${Theme.get('spacing') * 4}px;
        }

        .TopNavigationLevel2Section__list {
          width: 100%;
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .TopNavigationLevel2Section__category-link {
          margin-bottom: ${Theme.get('spacing') * 4}px;
        }

        .TopNavigationLevel2Section--no-header .TopNavigationLevel2Section__list {
          margin-top: ${Theme.get('spacing') * 5}px;
        }
      `}
    </style>
  </div>
);

Level2Section.propTypes = {
  l2Option: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    layoutRowPosition: PropTypes.number,
    layoutColumnPosition: PropTypes.number,
    subNavigations: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string.isRequired,
    mainLinkUrl: PropTypes.string,
  }).isRequired,
  trackNavigation: PropTypes.func.isRequired,
  trackNavigationClick: PropTypes.func.isRequired,
  l1Label: PropTypes.string.isRequired,
};

Level2Section.defaultPropTypes = {
  l2Option: {
    mainLinkUrl: undefined,
  },
};

export default Level2Section;
